import { Component, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ConnectedUserModel } from '../../interfaces/users-models';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class HomeComponent implements OnDestroy {
  connectedUser: ConnectedUserModel | null;
  isLoading = true;

  private usersService: UsersService;
  private subsCleanup: Subscription[] = [];

  constructor() {
    this.usersService = inject(UsersService);
    this.connectedUser = this.usersService.getConnectedUserSync();
  }

  ngOnDestroy(): void {
    for (const currSub of this.subsCleanup) {
      currSub.unsubscribe();
    }
  }
}
